import { Pipe, PipeTransform } from '@angular/core';
import { Glossary } from '../models/glossary.model';

/**Pipe che controlla se un glossario è privo di riferimenti */
@Pipe({
  name: 'unreferencedGlossary',
  pure: true
})
export class UnreferencedGlossaryPipe implements PipeTransform {

  /**
   * Metodo dell'interfaccia PipeTransform che effettua il controllo
   * @param voceGlos {Glossary} la voce di glossario da verificare
   */
  transform(voceGlos: Glossary): boolean {
    return voceGlos.translationCount > 0 ? false : true;
  }

}
